/* eslint-disable react/jsx-pascal-case */
import {
  CmpSelectBox,
  CmpButton,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useSelector } from "react-redux";
import { GetAttributes } from "./WmsPutAwayAction";

import { GetGitterColumns } from "../../Utility/Utilitys";
import moment from "moment";
import useMediaQuery from "@mui/material/useMediaQuery";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import WmsPutAway_BreadCrumbs from "./processComponent/WmsPutAwayBreadCrumbs";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { PutAwaySummary } from "../../Server/ApiV2";

export default function WmsPutAway() {
  const navigate = useNavigate();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const LocationFocusOnLoad = useRef(null);
  const vRdxuserInfo = useSelector((state) => state.login.value);
  const [Summary_Grid_Columns, setSummary_Grid_Columns] = useState([
    { field: "VocName", headerName: "VocName", flex: 1 },
    { field: "A_VocNo", headerName: "Voucher No", flex: 1 },
    {
      field: "A_PostDt",
      headerName: "Posting Date",
      type: "dateTime",
      flex: 1,
      valueFormatter: ({ value }) =>
        moment(value).format("DD/MM/YYYY") == "Invalid date"
          ? ""
          : moment(value).format("DD/MM/YYYY"),
    },
    { field: "A_RefNo", headerName: "Ref No", flex: 1 },
    { field: "PartyName", headerName: "Party Name", flex: 1.5 },
    { field: "LocName", headerName: "Location Name", flex: 1.5 },
    { field: "A_DocStat", headerName: "Doc Status", flex: 1 },
    { field: "A_VocTyp", headerName: "Voucher Type", flex: 1 },
  ]);
  const [sSummaryGridRow, setSummaryGridRow] = useState([
    {
      id: 1,
      VocName: "WMS GRN (INBOUND)",
      A_VocNo: "B99C011404",
      A_PostDt: "2025-03-11T00:00:00.000Z",
      A_RefNo: "3e3",
      PartyName: "FORTUNE INTERNATIONAL",
      LocName: "AL MADINA GLOBAL",
      A_DocStat: "POST",
      A_VocTyp: "WG001",
    },
  ]);
  const [sStatus, setStatus] = useState([
    {
      id: "ENTER",
      statusName: "ENTER",
    },
    {
      id: "DELETE",
      statusName: "DELETE",
    },
    {
      id: "POST",
      statusName: "POST",
    },
    {
      id: "CANCEL",
      statusName: "CANCEL",
    },
    {
      id: "DRAFT",
      statusName: "DRAFT",
    },
  ]);
  const [sLocTo, setLocTo] = useState([]);
  const [sSummaryObj, setSummaryObj] = useState({
    loc: "",

    dateFrom: new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 10
    ),
    dateTo: new Date(),
    status: "ENTER",
  });
  const fSummary_OnChange = (e) => {
    setSummaryObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  // modal start

  const [showModal, setShowModal] = useState(false);

  // modal end

  const fLoad = async(e) => {
   await Get_Load_Grid_Data(
      sSummaryObj.loc, 
      sSummaryObj.dateFrom,
      sSummaryObj.dateTo,
      sSummaryObj.status, 
    );
  };
  const Get_Load_Grid_Data = useCallback(
    async (xLoc, xDate1, xDate2, xStatus) => {
      var obj = {
        v_Loc: xLoc,
        v_FromDt: moment(xDate1).format("DD/MM/YYYY"),
        v_ToDt: moment(xDate2).format("DD/MM/YYYY"),
        v_Status: xStatus, 
      };
     

      const resp =  await PutAwaySummary(obj)

      if (resp?.status === 200) {
        if (resp?.data?.ResultSet?.length > 0) {
          const itemRows = resp?.data?.ResultSet?.map((obj, i) => ({
            ...obj,
            id: i + 1, 
          }));
          setSummaryGridRow(itemRows);
          setShowModal(false);
        } else {
          setSummaryGridRow([]);
          setShowModal(false);
        }
      }
    },
    []
  );

  const fRowClick = (e) => {
    navigate("/WmsPutAwayDetail", {
      state: {
        VocTyp: e?.row?.A_VocNo,
        VocNo: e?.row?.A_VocTyp,
      },
    });
  };

  const fOnLoad = useCallback(async () => {
    let iAttributeResp = await GetAttributes(setLocTo);
 
    if (iAttributeResp.length  > 0) {
      setSummaryObj((obj) => ({
        ...obj,
        loc: iAttributeResp[0]?.LocId,
      }));
      Get_Load_Grid_Data(
        iAttributeResp[0]?.LocId,
        sSummaryObj.dateFrom,
        sSummaryObj.dateTo,
        sSummaryObj.status
      );
    }
  }, []);
  useEffect(() => {
    fOnLoad();
  }, [fOnLoad]);

  useEffect(() => {
    // LocationFocusOnLoad?.current.focus();
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        <WmsPutAway_BreadCrumbs />
        <CmpButton
          xbtnName="Filter"
          xOnClick={() => {
            setShowModal(true);
          }}
          xVariant="contained"
          xSize="small"
        />
      </div>
      <div>
        <>
          <Box sx={{ height: vMediaQuery ? "50vh" : "70vh", width: "100%" }}>
            <DataGridPro
              rowHeight={30}
              headerHeight={40}
              getRowClassName={(params) =>
                params.indexRelativeToCurrentPage % 2 === 0
                  ? "mui-even-row"
                  : "mui-odd-row"
              }
              sx={{
                border: 1,
                borderColor: "primary.light",
              }}
              rows={sSummaryGridRow}
              columns={Summary_Grid_Columns}
              hideFooter={true}
              onRowClick={fRowClick}
              components={{
                Toolbar: vMediaQuery ? "" : GridToolbar,
              }}
            />
          </Box>
        </>
      </div>
      <GCSummaryModal
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter"
        component={
          <>
            <Grid container spacing={2} className="align-items-center">
              <Grid item xs={6}>
                <CmpDatePicker
                  xLabelText={"From"}
                  xValue={sSummaryObj.dateFrom}
                  xOnChange={(newValue) => {
                    setSummaryObj((obj) => ({
                      ...obj,
                      dateFrom: newValue.$d,
                    }));
                  }}
                  xName={"dateFrom"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpDatePicker
                  xLabelText={"To"}
                  xValue={sSummaryObj.dateTo}
                  xOnChange={(newValue) =>
                    setSummaryObj((obj) => ({ ...obj, dateTo: newValue.$d }))
                  }
                  xName={"dateTo"}
                  xError={false}
                  xErrorMessage={false}
                />
              </Grid>

              <Grid item xs={6} className="bintransfer-data-date">
                <CmpSelectBox
                  xLabelText="To Location"
                  xValue={sSummaryObj.loc}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"loc"}
                  xData={sLocTo}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={6} className="bintransfer-data-date">
                <CmpSelectBox
                  xLabelText="Status"
                  xValue={sSummaryObj?.status}
                  xOnChange={(event) => fSummary_OnChange(event)}
                  xName={"status"}
                  xData={sStatus}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>

              <Grid
                container
                spacing={{ xs: 2, sm: 2, md: 0 }}
                className="align-items-center pt-2"
              >
                <Grid
                  item
                  xs={12}
                  className="bintransfet-data-load-btn text-center"
                >
                  <CmpButton
                    xbtnName="Load"
                    xOnClick={fLoad}
                    xVariant="contained"
                    xSize="small"
                  />
                </Grid>

              
              </Grid>
            </Grid>
          </>
        }
      />
    </div>
  );
}
